import { Buffer } from 'buffer'

export function polyfills() {
  window.global = window
  window.Buffer = Buffer
  window.process = window.process ?? { env: {} } // Minimal process polyfill
}
